// jQuery
window.$ = window.jQuery = require('jquery');
let $ = require("jquery");

// Lightbox
require('./fslightbox-pro-3.4.1/fslightbox')

$(document).ready(function() {

    /* Toogle mobile menu */
    $(".navbar-mobile-toggle").click(function() {
        $('.navbar-mobile').toggleClass('hidden');
    });

    /* Submenu on page content toggle */
    let submenuNavItem       = $('.submenu-nav-item[data-box]');
    let toggleContentBox    = $('.toggle-content-box');

    submenuNavItem.click(function() {
        event.preventDefault();

        /* Switch active button */
        submenuNavItem.removeClass('active');
        $(this).addClass('active');

        /* Switch box with content */
        let contentBox = $(this).data('box');
        toggleContentBox.hide();
        $('.' + contentBox).show();
    });

});

/* Wrap articles table into wrapper */
export const wrapArticleContentTable = (table) => { table.wrap("<div class='table-wrapper'></div>"); };
wrapArticleContentTable($(".content-page table"));

/* Navbar scroll styling */
const TOP_BREAKPOINT = 200;
let breakpoint = false;
let navbar = $('.main-navbar');
let navbarSmallerClass = 'navbar-smaller';

$(window).scroll(function() {
    if ($(this).scrollTop() > TOP_BREAKPOINT && !breakpoint ) {
        breakpoint = true;
        navbar.addClass(navbarSmallerClass);
    }
    if ($(this).scrollTop() < TOP_BREAKPOINT && breakpoint ) {
        breakpoint = false;
        navbar.removeClass(navbarSmallerClass);
    }
})

// ------------ HOMEPAGE CAROUSEL
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

const homepageCarousel = new Swiper('.swiper', {
    speed: 2000,
    modules: [Autoplay, Navigation, Pagination],
    autoplay: {
        delay: 2500,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

// ------------ LUNCH CANCEL FORM VALIDATION
let moment                         = require('moment');
let now                            = moment();
let firstPossibleCancelDate        = moment().startOf('day').add(1, 'days'); // Tomorrow
let launchCancelFormElement        = $('.launch-cancel');
let launchCancelFromDateElement    = $('.launch-cancel .from-date');
let launchCancelToDateElement    = $('.launch-cancel .to-date');

// Save dates to storage
function setStorageDates(fromDate, toDate) {
    sessionStorage.setItem(STORAGE_NAME_FROM_DATE, fromDate);
    sessionStorage.setItem(STORAGE_NAME_TO_DATE, toDate);
}

// If is after midday > move first possible cancel date to next day
let todaysMidday = moment().startOf('day').add(moment.duration(12, 'hours'));
if (now > todaysMidday) firstPossibleCancelDate.add(1, 'days');

// Validate date
launchCancelFormElement.submit(function(e) {
    let isValidated         = launchCancelFormElement.data('validated');
    let fromDateInputValue  = launchCancelFromDateElement.val();
    let toDateInputValue    = launchCancelToDateElement.val();

    // If form hasn't been validated yet
    if (!isValidated) {
        e.preventDefault();

        if (fromDateInputValue === '') alert('Vyplňte prosím datum od'); // No date entered
        else {
            let usersFromDate = moment(launchCancelFromDateElement.val()); // From date entered by user
            if (usersFromDate >= firstPossibleCancelDate) {
                launchCancelFormElement.data('validated', true);
                launchCancelFormElement.submit();
            }
            else alert('Na tento den není možné oběd odhlásit. Nejbližší datum pro odhlášení oběda je ' + firstPossibleCancelDate.format('DD.MM.YYYY'));
        }
    } else {
        // Save dates to cache
        let fromDateFormated = moment(fromDateInputValue).format('DD.MM.');
        let toDateFormated   = moment(toDateInputValue).format('DD.MM.');
        setStorageDates(fromDateFormated, toDateFormated);
    }
});

/* Alerts dismiss */
let alertsComponent = $('.alert-box');
if (alertsComponent.length > 0)
    alertsComponent.delay(5000).fadeOut('slow');
